export const DOCTORS = [
    {
        slug: 'dr-irma-ariandi',
        key: 'irma',
        name: 'Dr. Irma Ariandi',
        short: 'Dr. Irma',
        creds: 'DDS (UKM)',
        photo: '/img/dr-irma.jpg',
    },
    {
        slug: 'dr-ariandi',
        key: 'ariandi',
        name: 'Dr. Ariandi',
        short: 'Dr. Ariandi',
        creds: 'DDS (UKM)',
        photo: '/img/dr-ariandi.jpg',
    },
];

export const getDoctor = (slug) => DOCTORS.find((d) => d.slug === slug);
